<template>
  <section class="container">
    <div class="left">
      <Loading v-show="loading"></Loading>
      <h3>{{ info.title }}</h3>
      <div class="rich" v-html="info.content"></div>
      <div class="buttom">
        <router-link v-if="pageother?.prveinfo?.id" class="prev iconfont icon-jiantou-copy"
          :to="{ path: '/news/info', query: { id: pageother?.prveinfo?.id } }">
          <span class="dh_text">Prev:{{ pageother?.prveinfo?.title }}</span>
        </router-link>
        <a v-else class="prev dh_text iconfont icon-jiantou-copy" href="JavaScript:;">Prev: none</a>
        <router-link :to="{ path: '/news' }">back</router-link>
        <router-link v-if="pageother?.nextinfo?.id" class="next iconfont icon-jiantou"
          :to="{ path: '/news/info', query: { id: pageother?.nextinfo?.id } }">
          <span class="dh_text">Next：{{ pageother?.nextinfo?.title }}</span>
        </router-link>
        <a v-else class="next dh_text iconfont icon-jiantou" href="JavaScript:;">Next：none</a>
      </div>
    </div>
    <div class="right">
      <h4>Recommended articles</h4>
      <ul>
        <router-link v-for="item in recommend_news" :key="item.id" :to="{ path: '/news/info', query: { id: item.id } }"
          class="dh_text">{{ item.title }}</router-link>
      </ul>
    </div>
  </section>
</template>

<script>
import service from "@/assets/js/service";

export default {
  data() {
    return {
      loading: false,
      pageother: {},
      info: {},
      recommend_news: [],
      id: this.$route.query.id,
    };
  },
  created() {
    this.newsInfo();
  },
  methods: {
    async newsInfo() {
      this.loading = true;
      let res = await service.newsInfo({ id: this.id });
      this.loading = false;
      this.info = res.data.newsinfo;

      let ss = `src="${this.$baseURL}`;
      this.info.content = this.info.content.split(`src="`).join(ss);
      this.pageother = res.data.pageother;
      this.recommend_news = res.data.recommend_news;
    },
  },
  watch: {
    $route(to, from) {
      this.id = to.query.id;
      this.newsInfo();
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  display: flex;

  .left {
    flex: 1;
    padding-right: 40px;
    border-right: 1px solid #ddd;
    margin-right: 40px;

    h3 {
      margin-bottom: 20px;
      border-bottom: 1px solid #ddd;
      padding-bottom: 20px;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      line-height: 1;

      .date {
        font-weight: 400;
        font-size: 14px;
        color: #999;
      }
    }

    .buttom {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      border-top: 1px solid #ddd;
      padding-top: 20px;
      font-size: 14px;
      color: #666;

      a {
        max-width: 25%;
        color: var(--themeColor);
        font-size: 16px;
      }

      .prev,
      .next {
        display: flex;
        font-family: Regular !important;
        color: #666;

        &::before {
          font-family: iconfont !important;
          color: var(--themeColor2);
          margin-right: 10px;
        }
      }

      .next {
        display: flex;
        flex-direction: row-reverse;

        &::before {
          margin-left: 10px;
          margin-right: 0;
        }
      }
    }
  }

  .right {
    width: 25%;

    h4 {
      font-weight: 400;
      font-size: 18px;
    }

    ul {
      margin-top: 20px;

      a {
        color: #666;
        padding-left: 15px;
        position: relative;
        display: block;
        transition: all 0.3s;

        &::after {
          content: "";
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: var(--themeColor);
          position: absolute;
          left: 3px;
          top: 50%;
          transform: translateY(-50%);
          transition: all 0.3s;
        }

        &+a {
          margin-top: 20px;
        }

        &:hover {
          color: var(--themeColor2);

          &::after {
            background: var(--themeColor2);
          }
        }
      }
    }
  }
}

@media (max-width: 700px) {
  .container {
    display: block;

    .left {
      padding: 0;
      margin: 0;
      border: none;
    }

    .right {
      margin-top: 30px;
      width: 100%;
    }
  }
}
</style>